import React from 'react';

const Footer: React.FC = () => {
    return (
        <footer className="bg-[#f5f5f5] text-gray-800 border-t">
            <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
                    {/* Brand + intro */}
                    <div className="lg:col-span-2">
                        <div className="flex items-center gap-3">
                            <div className="w-12 h-12 rounded bg-[#da291c] grid place-items-center text-white font-bold">JJ</div>
                            <div className="font-semibold">Jeevan Jyoti Foundation</div>
                        </div>
                        <p className="mt-4 text-sm leading-6 text-gray-600">
                            The Jeevan Jyoti Foundation is a non profit organisation that strives to
                            eliminate classroom hunger by implementing community programs.
                        </p>
                        <div className="mt-5 flex items-center gap-4 text-[#da291c]">
                            <a aria-label="Instagram" href="#" className="w-9 h-9 rounded-full border grid place-items-center">IG</a>
                            <a aria-label="LinkedIn" href="#" className="w-9 h-9 rounded-full border grid place-items-center">in</a>
                            <a aria-label="Facebook" href="#" className="w-9 h-9 rounded-full border grid place-items-center">f</a>
                            <a aria-label="Twitter" href="#" className="w-9 h-9 rounded-full border grid place-items-center">𝕏</a>
                            <a aria-label="YouTube" href="#" className="w-9 h-9 rounded-full border grid place-items-center">▶</a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <div className="font-semibold mb-3">QUICK LINKS</div>
                        <ul className="space-y-2 text-sm text-gray-700">
                            <li><a href="#" className="hover:text-[#da291c]">About Us</a></li>
                            <li><a href="#" className="hover:text-[#da291c]">Services</a></li>
                            <li><a href="#" className="hover:text-[#da291c]">Gallery</a></li>
                            <li><a href="#" className="hover:text-[#da291c]">Contact</a></li>
                            <li><a href="#" className="hover:text-[#da291c]">Policy Privacy</a></li>
                            <li><a href="#" className="hover:text-[#da291c]">Terms and Conditions</a></li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <div className="font-semibold mb-3">CONTACT INFO</div>
                        <div className="space-y-3 text-sm text-gray-700">
                            <div className="flex items-start gap-2">
                                <svg className="w-5 h-5 flex-shrink-0 mt-0.5 text-[#da291c]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                <span>Lorem ipsum dolor sit amet consectetur adipisicing elit.</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <svg className="w-5 h-5 flex-shrink-0 text-[#da291c]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                </svg>
                                <a href="mailto:navtazdham@gmail.com" className="hover:text-[#da291c]">jyotijeevan@gmail.com</a>
                            </div>
                            <div className="flex items-center gap-2">
                                <svg className="w-5 h-5 flex-shrink-0 text-[#da291c]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                </svg>
                                <div className="space-y-1">
                                    <a href="tel:+919225097439" className="block hover:text-[#da291c]">+91 9225097439</a>
                                    <a href="tel:+919011262226" className="block hover:text-[#da291c]">+91 9011262226</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Donate / Get in touch / Get involved */}
                    <div>
                        <div className="font-semibold mb-3">DONATE</div>
                        <ul className="space-y-2 text-sm text-gray-700">
                            <li><a href="#" className="hover:text-[#da291c]">Online donations</a></li>
                            <li><a href="#" className="hover:text-[#da291c]">Sponsor a School</a></li>
                            <li><a href="#" className="hover:text-[#da291c]">Sponsor a kitchen</a></li>
                        </ul>
                        <div className="font-semibold mt-5 mb-3">GET IN TOUCH</div>
                        <div className="text-sm text-gray-700">Contact Us</div>
                        <div className="font-semibold mt-5 mb-3">GET INVOLVED</div>
                        <div className="text-sm text-gray-700">Future shaper</div>
                    </div>
                </div>

                <div className="mt-10 pt-6 border-t text-sm text-gray-600 flex flex-col md:flex-row gap-3 md:items-center md:justify-between">
                    {/* <div>Charity Id : AAATT6468P</div> */}
                    <div> {new Date().getFullYear()} Jeevan Jyoti Foundation</div>
                </div>
            </div>

            {/* Bottom silhouette background image band. Place your image at public/images/footer/silhouette.png */}
            <div
                className="w-full h-40 bg-no-repeat bg-bottom bg-cover"
                style={{ backgroundImage: "url('/jeevan-jyoti-ngo/images/footer/Untitled design.png')" }}
            />
        </footer>
    );
};

export default Footer;